import React, { useState, useEffect } from 'react'
import { ProsimPromotional as AppPopup } from 'apps-marketplace'
import { SidebarV2Link, NavItemIcon, NavItem } from 'navigation'
import api from 'api'

/**
 * Nav Item Button to open the App Popup.
 */
const AppPromoButton = ({ navItem, navUI }: { navItem: NavItem, navUI: string }) => {
    const [showPromoButton, setShowPromoButton] = useState(false)
    const [showAppPopup, setShowAppPopup] = useState(false)

    useEffect(() => {
        const shouldVisible = !(localStorage.getItem('appPopup-clicked') === 'true')
        const isMobile = window.matchMedia("(max-width: 600px)")
        if (!shouldVisible || isMobile.matches) {
            setShowPromoButton(false)
            return
        }

        (async () => {
            try {
                const response = await api.fetchEsims()
                const fetchedEsims = response.data || []
                if (fetchedEsims.length) return setShowPromoButton(false)
                setShowPromoButton(true)
            } catch (error) {
                console.error('Failed to fetch eSIMs:', error)
            }
        })()
    }, [])

    if (navUI === 'NavUIV1') {
        console.warn('App Promo Button: is not yet supported on Nav UI V1, it will intentionally not be visible on the sidebar')
        return <></>
    }

    const onClick = () => setShowAppPopup(true)

    if (!showPromoButton) return <></>

    return (
        <>
            <SidebarV2Link
                icon={<NavItemIcon navItem={navItem} />}
                title={navItem.title}
                animate={!showAppPopup}
                onClick={onClick}
            />
            <AppPopup {...{ showAppPopup, setShowAppPopup }} />
        </>
    )
}

export default AppPromoButton
